import { ChangeEvent, FormEvent } from 'react';
import clsx from 'clsx';
// eslint-disable-next-line
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link, NaosButton, Input } from '@dtsl/react';
import { setUsername } from '../../../utils/indexedDB/indexedDB';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../LanguageSelector/LanguageSelector';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    marginBottom: '1em',
  },
  gutterBottom: {
    marginBottom: '2em',
  },
  inputContainer: {
    paddingBottom: '2em',
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  continueButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  footer: {
    textAlign: 'center',
  },
}));

interface RoomScreenProps {
  name: string;
  slug: string;
  room: string;
  setName: (name: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomScreen({ name, slug, room, setName, handleSubmit }: RoomScreenProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
    setName(event.target.value);
  };

  return (
    <>
      <div className={clsx(classes.header, 'sib-typo_heading-md')}>{t('PREVIEW.NAME.TITLE')}</div>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          <Input
            id="input-user-name"
            type="text"
            style={{ width: '100%' }}
            placeholder={t('PREVIEW.NAME.INPUT.LABEL')}
            value={name}
            onChange={handleNameChange}
          />
        </div>
        <>
          <p className={clsx(classes.header, 'sib-typo_text-body')}>
            {t('PREVIEW.NAME.CONSENT_1')}
            <Link
              id="video-calls-terms-of-use"
              url="https://www.brevo.com/legal/termsofuse/"
              variant="external"
              labelText={t('PREVIEW.NAME.CONSENT_2')}
            />
            {t('PREVIEW.NAME.CONSENT_3')}
          </p>
          <p className={clsx(classes.gutterBottom, 'sib-typo_text-body')}>
            {t('PREVIEW.NAME.LOGIN_1')}
            <Link
              id="video-calls-login"
              url="https://app.brevo.com/account/login"
              variant="default"
              labelText={t('PREVIEW.NAME.LOGIN_2')}
            />
          </p>
        </>
        <div className={classes.continueButton}>
          <LanguageSelector />
          <NaosButton
            id="video-calls-name-save"
            variant="primary"
            color="primary"
            label={t('PREVIEW.NAME.INPUT.SUBMIT')}
            type="submit"
            disabled={!name || !room || !slug}
          ></NaosButton>
        </div>
      </form>
    </>
  );
}
